<template>
  <div>
    <!-- SIDEBAR -->
    <nav v-show="propsdata[0].sidebar_mobile" id="sidebarMenu" class="sidebar d-md-block" style="background-color: #ffffff!important;border-right: 1px solid #dde1ed!important;display: none;">
       <div class="sidebar-inner p-4">
          <button @click="$emit('togglesidebar')" class="btn btn-md btn-light py-0 px-2 d-md-none" style="position: absolute; right: 15px; top: 15px; font-size: 22px;">
            <i class="fas fa-times"></i>
          </button>
          <ul style="margin-top: 70px;" class="nav flex-column sidebar-top-mobile">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <p style="margin-left: 11px;" class="font-weight-bolder text-dark mb-0">
                <i class="fas fa-qrcode" style="margin-right: 7px;"></i>{{propsdata[0]['translation']['sidebar-title']}} 
              </p>
              <span v-if="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].cargado">
                <span class="badge badge-md bg-danger ms-1" style="display: block;background-color: rgb(220, 53, 69)!important;color:#ffffff!important;">{{propsdata[0]['translation']['sidebar-deactivated']}}</span>
              </span>
            </div>
            <li class="nav-item" @click="$emit('togglesidebar')"><router-link to="/dashboard/" active-class="selected" class="nav-link router-link-active"><i class="fas fa-chart-line mr-2"></i> <span class="sidebar-text">{{propsdata[0]['translation']['sidebar-tab-active']}}</span></router-link></li>
            <li class="nav-item" @click="$emit('togglesidebar')"><router-link to="/dashboard/archived" active-class="selected" class="nav-link router-link-active"><i class="fas fa-archive mr-2"></i> <span class="sidebar-text">{{propsdata[0]['translation']['sidebar-tab-archived']}}</span></router-link></li>
            <li class="nav-item" @click="$emit('togglesidebar')"><router-link v-if="propsdata[0].api_qr_codes === 'yes'" active-class="selected" to="/dashboard/api-qr-codes" class="nav-link"><i class="fas fa-bezier-curve mr-2"></i> <span class="sidebar-text">{{propsdata[0]['translation']['sidebar-tab-api-qr-codes']}}</span></router-link></li>
            <li class="nav-item" @click="$emit('togglesidebar')"><router-link to="/dashboard/general-stats" active-class="selected" class="nav-link router-link-active"><i class="fas fa-chart-bar mr-2"></i> <span class="sidebar-text">{{propsdata[0]['translation']['sidebar-tab-stats']}}</span></router-link></li>
            <li role="separator" class="dropdown-divider mt-4 mb-4 border-black" style="border-color: #dde1ed!important;"></li>
            <p style="margin-left: 11px; margin-bottom: 0.8rem; font-weight: 900; color: rgb(42, 53, 79); font-size: 15px;"><i class="fas fa-clone" style="margin-right: 7px;"></i>{{propsdata[0]['translation']['sidebar-tab-templates']}} <span style="float: right; display: none;"><span class="badge badge-md bg-danger ms-1" style="display: block; background-color: rgb(220, 53, 69) !important; color: rgb(255, 255, 255) !important;">{{propsdata[0]['translation']['sidebar-tab-templates-paused']}}</span></span></p>
            <li class="nav-item" @click="$emit('togglesidebar')"><router-link to="/dashboard/saved-designs" class="nav-link router-link-active selected"><i class="fas fa-qrcode mr-2"></i> <span class="sidebar-text">{{propsdata[0]['translation']['sidebar-tab-saved-designs']}}</span></router-link></li>
            <li role="separator" class="dropdown-divider mt-4 mb-4 border-black" style="border-color: #dde1ed!important;"></li>
            <p style="margin-left: 11px;margin-bottom: 0.8rem;font-weight: 900;color: #2a354f;font-size: 15px;"><i class="fas fa-folder" style="margin-right: 7px;"></i>{{propsdata[0]['translation']['sidebar-tab-folders']}}</p>
            <li class="nav-item" style="margin-bottom: 10px;" @click="$emit('togglesidebar')">
              <button v-if="(propsdata[0].paid === 'yes' || propsdata[0].freetrial === 'yes') && propsdata[0].access_limit !== 'limited'" @click="ShowModal" class="btn btn-md btn-secondary w-100 animate-up-2">
                <i class="fas fa-plus mr-1"></i>
                {{propsdata[0]['translation']['sidebar-tab-new-folder']}}
              </button>
              <button v-if="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].access_limit !== 'limited'" @click="propsdata[0].upgrade_modal = true" class="btn btn-md btn-secondary w-100 animate-up-2">
                <i class="fas fa-plus mr-1"></i>
                {{propsdata[0]['translation']['sidebar-tab-new-folder']}}
              </button>
            </li>
            <li class="nav-item" v-for="folder in propsdata[0].folders" @click="$emit('togglesidebar')">
              <router-link active-class="selected" class="nav-link" :to="'/dashboard/folder/'+folder.id" style="border-bottom: none;"><span class="sidebar-text" style="display: block; white-space: nowrap; text-overflow: ellipsis; max-width: 200px; overflow: hidden;">{{folder.name}}</span></router-link>
            </li>
            <li v-if="propsdata[0].freetrial === 'yes' && propsdata[0].cargado" class="nav-item" style="height: 50px;">
              <a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_on_trial'" class="btn btn-md btn-outline-secondary animate-up-2" style="color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); position: fixed; bottom: 15px; width: 212px;">
                <i class="fas fa-crown mr-1" style="color: #f4bd00;"></i>
                {{propsdata[0]['translation']['sidebar-upgrade-button']}}
              </a>
            </li>
            <li v-if="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].cargado" style="height: 50px;">
              <a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_trial_expired'" class="btn btn-md btn-outline-secondary animate-up-2" style="color: rgb(0, 0, 0); background-color: #ffffff; position: fixed; bottom: 15px; width: 212px;">
                <i class="fas fa-crown mr-1" style="color: #f4bd00;"></i>
                {{propsdata[0]['translation']['sidebar-upgrade-button']}}
              </a>
            </li>
          </ul>
       </div>
    </nav>

    <!-- FREE TRIAL MESSAGE -->
    <div v-show="propsdata[0].freetrial === 'yes' && propsdata[0].cargado" class="nopagonav content2" style="z-index: 2;position: relative;top: 68px;padding: 0;display:none;">
      <div style="color: #15a97c;background-color: rgb(255, 255, 255);border-color: #15a97c;width: 100%;display: inline-block;font-weight: 600;text-align: center;border: 0.0625rem solid;padding: 0.55rem 0.95rem;">{{propsdata[0]['translation']['sidebar-free-trial-1']}} <a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_on_trial'" style="text-decoration: underline;color: #15a97c;font-weight: 600;">{{propsdata[0]['translation']['sidebar-free-trial-2']}}</a>.</div>
    </div>
    <!-- TRIAL EXPIRED MESSAGE -->
    <div v-show="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].cargado" class="nopagonav content2" style="z-index: 2;position: relative;top: 68px;padding: 0;display:none;">
      <div style="color: rgb(255 255 255);background-color: #dc3545;border-color: #dc3545;width: 100%;padding: 0.55rem 0.95rem;letter-spacing: .025em;text-align: center;" class="">
        <h6 style="margin-bottom: 5px;color: #ffffff;">{{propsdata[0]['translation']['sidebar-free-trial-expired-1']}}</h6>
        <p style="margin-bottom: 0;"><a :href="'/choose-plan/'+propsdata[0].unique_id+'?utm_campaign=dashboard_trial_expired'" style="color: #ffffff;text-decoration: underline;">{{propsdata[0]['translation']['sidebar-free-trial-expired-2']}}</a>{{propsdata[0]['translation']['sidebar-free-trial-expired-3']}}</p>
      </div>
    </div>
    <!-- LAST PAYMENT FAILED MESSAGE -->
    <div v-show="propsdata[0].paid !== 'yes' && propsdata[0].freetrial !== 'yes' && propsdata[0].canceled_due_attempt2 === 'yes' && propsdata[0].cargado" class="nopagonav content2" style="z-index: 2;position: relative;top: 68px;padding: 0;display:none;">
      <div style="color: rgb(255 255 255);background-color: #dc3545;border-color: #dc3545;width: 100%;padding: 0.55rem 0.95rem;letter-spacing: .025em;text-align: center;" class="">
        <h6 style="margin-bottom: 5px;color: #ffffff;">{{propsdata[0]['translation']['sidebar-last-payment-failed-1']}}</h6>
        <p style="margin-bottom: 0;">{{propsdata[0]['translation']['sidebar-last-payment-failed-2']}} <router-link to="/dashboard/billing" style="color: #ffffff;text-decoration: underline;">{{propsdata[0]['translation']['sidebar-last-payment-failed-3']}}</router-link>{{propsdata[0]['translation']['sidebar-last-payment-failed-4']}}</p>
      </div>
    </div>

    <!-- Modal Content -->
    <div v-if="modal" @click="HideModal" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
      <div @click.stop class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header w-100">
            <p class="lead mb-0">{{propsdata[0]['translation']['sidebar-modal-folder-header']}}</p>
            <button @click="HideModal" type="button" class="close ml-auto">
              <span style="color: rgb(0, 0, 0);">×</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 class="modal-title mb-3" style="color: rgb(0, 0, 0);">{{propsdata[0]['translation']['sidebar-modal-folder-title']}}</h3>
            <div class="text-center">
              <div class="form-group mb-0">
                <div class="d-sm-flex flex-column flex-sm-row mb-0 justify-content-center">
                  <input v-model="foldername" type="text" :placeholder="propsdata[0]['translation']['sidebar-modal-folder-placeholder']" class="mr-sm-1 mb-2 mb-sm-0 form-control form-control-lg">
                  <button v-if="!savingfolder" @click="savefolder" class="ml-sm-1 btn btn-secondary" style="width: 30%;">{{propsdata[0]['translation']['sidebar-modal-folder-save']}}</button>
                  <button v-if="savingfolder" class="ml-sm-1 btn btn-secondary" style="width: 30%;">{{propsdata[0]['translation']['sidebar-modal-folder-saving']}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Modal Content -->
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props:['propsdata'],
  data(){
    return {
      folders: [],
      modal: false,
      foldername: '',
      savingfolder: false
    }
  },
  methods: {
    ShowModal(){
      this.modal = true;
    },
    HideModal(){
      this.modal = false;
    },
    savefolder(){
      this.savingfolder = true;
      axios.post('/dashboard/save-folder.php', {
        foldername: this.foldername
        })
        .then(response => {
          this.$emit('updatefolders');
          this.modal = false;
          this.savingfolder = false;
          this.foldername = '';
          // this.$router.push('/dashboard/folder/'+response.data[0].id);
      })
        .catch(function (error) {
          console.log(error);
        });
    }
},
mounted(){
},
// do not forget this section
directives: {
ClickOutside
}
};
</script>



// WEBPACK FOOTER //
// src/sidebar.vue